export default {
  namespaced: true,
  state: {
    guarantees: [],
    certificates: [],
  },
  actions: {
    GetList({ commit, rootGetters }, payload) {
      commit('setField', { name: 'guarantees', value: [] });
      rootGetters.axl.post('guarantees/api/guarantee/list', payload).then((response) => {
        commit('setField', {
          name: 'guarantees',
          value: response.data.items,
        });
      });
    },
    GetCertificates({ commit, rootGetters }, payload) {
      commit('setField', { name: 'certificates', value: [] });
      rootGetters.axl.post('seminars/api/certificates', payload).then((response) => {
        commit('setField', {
          name: 'certificates',
          value: response.data?.items,
        });
      });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
